import Api from './Api';
import React from 'react';
import {
    HashRouter as Router,
    Switch,
    Route,
} from 'react-router-dom';
import SSO from '../utilities/sso';
import { jsonParse } from '../../Libraries/helpers';
import AdvancedEditPage from './Pages/AdvancedEditPage';
import DashboardPage from './Pages/DashboardPage';
import { DatabaseProvider } from './DatabaseContext';
import DimensionsPage from './Pages/DimensionsPage';
import ErrorProvider from './Fields/ErrorsContext';
import LocationPage from './Pages/LocationPage';
import PoolNamePage from './Pages/PoolNamePage';
import ScrollToTop from './Components/ScrollToTop';
import PowerPage from './Pages/PowerPage';
import RecommendationPage from './Pages/RecommendationPage';
import SeasonPage from './Pages/SeasonPage';
import SplashPage from './Pages/SplashPage';
import I18nProvider from '../utilities/i18n'
import SummaryPage from './Pages/SummaryPage';
import TemperaturePage from './Pages/TemperaturePage';

export default function PoolHeaterTool({ i18n, sso, api }) {
    i18n = jsonParse(i18n);
    api = jsonParse(api);

    SSO.setOptions(jsonParse(sso))

    Api.setOptions({
        baseURL: `${api.endpoint}/api`,
    })

    return <Router>
        <ScrollToTop />
        <I18nProvider value={i18n}>
            <ErrorProvider>
                <DatabaseProvider>
                    { SSO.getIdentity() ? <Switch>
                        <Route exact path="/">
                            <DashboardPage i18n={i18n} />
                        </Route>
                        <Route path="/new">
                            <PoolNamePage i18n={i18n} />
                        </Route>
                        <Route path="/:id/name">
                            <PoolNamePage i18n={i18n} />
                        </Route>
                        <Route path="/:id/dimensions">
                            <DimensionsPage i18n={i18n} />
                        </Route>
                        <Route path="/:id/temperature">
                            <TemperaturePage i18n={i18n} />
                        </Route>
                        <Route path="/:id/location">
                            <LocationPage i18n={i18n} />
                        </Route>
                        <Route path="/:id/seasons">
                            <SeasonPage i18n={i18n} />
                        </Route>
                        <Route path="/:id/power">
                            <PowerPage i18n={i18n} />
                        </Route>
                        <Route path="/:id/summary">
                            <SummaryPage i18n={i18n} />
                        </Route>
                        <Route path="/:id/advanced">
                            <AdvancedEditPage i18n={i18n} />
                        </Route>
                        <Route path="/:id/recommendations">
                            <RecommendationPage i18n={i18n} />
                        </Route>
                    </Switch> : <SplashPage i18n={i18n} /> }
                    <div className="mt-6 lg:mt-10 py-4 border-t border-grey-300 opacity-75">
                        <a href={ i18n.terms.url } className="text-sm hover:underline" target="_blank" rel="noopener noreferrer">{ i18n.terms.text }</a>
                    </div>
                </DatabaseProvider>
            </ErrorProvider>
        </I18nProvider>
    </Router>
}
